//引入外部依赖
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
//新建store实例
const store = new Vuex.Store({
  state: {
    name: 'Rowland'
  },
  mutations: {
    changeName(state) {
      state.name = 'lily';
    }
  }
})
//导出store
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js